import App from './App.html'
import store from './_store.js'


window.store = store;

const app = new App({
    target: document.body,
    hydrate: true,
    store,
});

export default app;